<template>
  <div id="about-box">
    <h3 class="center">Unsere Geschichte:</h3>
    <h2 class="center">1924 wurde das Unternehmen Schreinerei Schill gegründet</h2>
    <h4 class="center">Unter Firmenleitung von Emil Schlenker hatte der Betrieb seinen Firmensitz in der Schwarzwaldstraße. Der Betrieb machte sich als Wagnerei, Skifabrik und im Karosseriebau einen Namen.</h4>

    <br>
    <div class="grid grid-24 justify-items-center center">
      <div class="col-span-24">
        <img class="img-frame" src="../assets/media/about/01.jpg">
      </div>
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/02.jpg">
      </div>
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/03.jpg">
      </div>
      <div class="col-span-24">
        <p>Hier fertigte man auch die ersten Kabinen der noch heute bestehenden Schauinslandbahn
        sowie Räder für Kutschen und Transportfahrzeuge.</p>
        <br>
        <p>Aber eine Spezialität der damaligen Schill-Handwerker war der Bau von Alpin-
        und Langlaufskiern</p>
      </div>
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/04.jpg">
      </div>
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/05.jpg">
      </div>
      <div class="col-span-24">
        <p>Der Weg vom Baum</p>
      </div>
      <div class="col-span-24">
        <img class="img-frame" src="../assets/media/about/06.jpg">
      </div>
      <div class="col-span-24">
        <p>über das rau gesägte Brett</p>
      </div>
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/07.jpg">
      </div>
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/08.jpg">
      </div>
      <div class="col-span-24">
        <p>das grobe Maß und die erste Oberflächenbearbeitung</p>
      </div>
      
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/09.jpg">
      </div>
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/10.jpg">
      </div>
      <div class="col-span-24">
        <p>über das Vorspannen im Rahmen führt in den "Holzkocher"</p>
      </div>
      
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/11.jpg">
      </div>
      <div class="above-xs-col-span-12 xs-col-span-24">
        <img class="img-frame" src="../assets/media/about/12.jpg">
      </div>
      <div class="col-span-24 justify-center">
        <p>und nach mehrtägigen Behandlung entsteht die typische Skiform.</p>
        <br>
        <p>und auch ohne DIN wird in einem abschließenden Arbeitsgang das Endprodukt nach Schill'scher Qualitätsnorm mit einem Feinschliff veredelt</p>
      </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  }
};
</script>

<style>
#about-box > .grid{
  max-width: 100%;
  width: 900px;
  margin: auto;
  grid-gap: 0;
}

#about-box .img-frame{
  max-width: 100%;
  max-height: none;
}

#about-box .grid > div{
  max-width: 100%;
  margin: 8px;
}
</style>
